import React, { useState, useEffect } from 'react';
import { userService } from '../api/services';

// 人員選擇彈窗：轉派用單選(single)、協作用多選(multi)。
// 從人員名錄 API 取得使用者清單，支援關鍵字搜尋；excludeIds 內的人員不顯示（例如已是負責人/協作者）。
const BountyPeoplePicker = ({ open, mode = 'single', title, confirmLabel = '確定', excludeIds = [], onClose, onConfirm }) => {
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);

  // 開啟時重置選取與搜尋
  useEffect(() => {
    if (open) {
      setSelected([]);
      setSearch('');
    }
  }, [open]);

  // 依搜尋字串載入人員（延遲 250ms 去抖動，避免每次按鍵都打 API）
  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(() => {
      userService.list({ search, limit: 50 })
        .then((res) => { if (!cancelled) setUsers(res.data?.items || []); })
        .catch(() => { if (!cancelled) setUsers([]); })
        .finally(() => { if (!cancelled) setLoading(false); });
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [search, open]);

  if (!open) return null;

  const excludeSet = new Set(excludeIds);
  const visibleUsers = users.filter((u) => !excludeSet.has(u.id));

  // selected 存「使用者物件」陣列，confirm 時回傳物件供呼叫端顯示姓名與取 id
  const isSelected = (id) => selected.some((s) => s.id === id);
  const toggle = (u) => {
    if (mode === 'single') {
      setSelected([u]);
      return;
    }
    setSelected((prev) => (prev.some((s) => s.id === u.id) ? prev.filter((s) => s.id !== u.id) : [...prev, u]));
  };

  const handleConfirm = () => {
    if (!selected.length) return;
    onConfirm(selected);
  };

  return (
    <div className="bounty-modal-overlay" onClick={onClose}>
      <div className="bounty-modal people-picker" onClick={(e) => e.stopPropagation()}>
        <div className="bounty-modal-header">
          <h3>{title || (mode === 'single' ? '選擇一位人員' : '選擇協作人員')}</h3>
          <button type="button" className="bounty-modal-close" onClick={onClose}>✕</button>
        </div>

        <input
          type="text"
          className="form-control people-search"
          placeholder="搜尋姓名 / 帳號 / LINE ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoFocus
        />

        <div className="people-list">
          {loading && <div className="people-empty">載入中...</div>}
          {!loading && visibleUsers.length === 0 && <div className="people-empty">查無人員</div>}
          {!loading && visibleUsers.map((u) => (
            <label key={u.id} className={`people-item ${isSelected(u.id) ? 'selected' : ''}`}>
              <input
                type={mode === 'single' ? 'radio' : 'checkbox'}
                name="people-pick"
                checked={isSelected(u.id)}
                onChange={() => toggle(u)}
              />
              <span className="people-avatar">{(u.display_name || u.name || '?').charAt(0).toUpperCase()}</span>
              <span className="people-name">{u.display_name || u.name}</span>
              {u.line_id && <span className="people-sub">{u.line_id}</span>}
            </label>
          ))}
        </div>

        <div className="bounty-modal-footer">
          <span className="people-count">{mode === 'multi' ? `已選 ${selected.length} 人` : ''}</span>
          <div>
            <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
            <button type="button" className="btn btn-primary" onClick={handleConfirm} disabled={!selected.length}>{confirmLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BountyPeoplePicker;
